import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as c from "../constant";
import Select from "react-select";

class JobSeeker extends Component {

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch({
      type: c.GET_WEB_CONTENT,
    });
  }

  handleOnChange = (e) => {
    e.preventDefault();
    const { dispatch } = this.props;
    const { name, value } = e.target;
    dispatch({
      type: c.SET_FORM_DATA,
      data: {
        [name]: value,
      },
    });
  };

  handleChangeSelect = (key) => (e) => {
    const { dispatch } = this.props;
    dispatch({
      type: c.SET_FORM_DATA,
      data: {
        [key]: e || "",
      },
    });
  };

  handleOnSubmit = (e) => {
    e.preventDefault();
    const { dispatch, form_data } = this.props;

    dispatch({
      type: c.CONTACT,
      args: {
        full_name: form_data.get("full_name"),
        contact: form_data.get("contact"),
        email: form_data.get("email"),
        message: form_data.get("message"),
        user: form_data.get("user"),
      },
    });
  };

  render() {
    const { form_data, loading, web_content } = this.props;
    const contact_number = web_content.toJS().find(item => item.tag_name === 'contact_numbers') || ''
    const office_hours = web_content.toJS().find(item => item.tag_name === 'office_hours') || ''

    return (
      <Fragment>
        <div className="page-title-banner _contact3-bg">
          <div className="title">
            <h1>Contact Us</h1>
          </div>
        </div>
        <iframe
          title="Office Map"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3860.7105445236334!2d121.0354664824265!3d14.61555806980852!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x241ae42c7e0f66b8!2sIPAMS%20Industrial%20Personnel%20and%20Management%20Services%2C%20Inc.!5e0!3m2!1sen!2sph!4v1566948767113!5m2!1sen!2sph"
          width="100%"
          height="450"
          frameborder="0"
          style={{ border: "0" }}
          allowfullscreen=""
        ></iframe>
        <div className="section  mt-5 container footer-clearance">
          <div className="row">
            <div className="col-md-5">
              <div className="box">
                <h3 className="mb-4 cx1">Contact Numbers</h3>
                <div dangerouslySetInnerHTML={{ __html:contact_number.content }} />
              </div>
              <div className="box">
                <h3 className="mb-2 cx1">IPAMS Address</h3>
                <p>
                  IPAMS Bldg., 723 Aurora Boulevard New Manila
                  <br />
                  Quezon City 1112 Philippines
                </p>
              </div>
              <div className="box">
                <h3 className="mb-4 cx1">Office Hours</h3>
                <div dangerouslySetInnerHTML={{ __html:office_hours.content }} />
              </div>
              <div className="box">
                <h3 className="mb-4 cx1">Directions</h3>
                <ul className="list-unstyled bullet">
                  <li>Between Balete Drive and Hemady Avenue</li>
                  <li>Right in front of Robinsons Magnolia Mall</li>
                  <li>
                    Between Land Bank of the Philippines (LBP) and Bank of the
                    Philippine Islands (BPI)
                  </li>
                  <li>A block away from St. Paul's University Quezon City</li>
                  <li>Between Gilmore and Betty Go-Belmonte LRT-2 Stations</li>
                </ul>
              </div>
            </div>
            <div className="col-md-7">
              <div className="row mt-sm-4">
                <div className="col-12">
                  <div className="col-12">
                    <h5 className="text-center text-italic p-5 bg-gray-light">
                      If you have any inquiries, send us a message.
                    </h5>
                  </div>
                </div>
              </div>

              <form class="label-top" onSubmit={this.handleOnSubmit}>
                <div className="row">
                  <div className="box news-box left col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="input-group mb-3 jobs-search-wrap flex-sm-column flex-md-row">
                      <label className="col-sm-12 font-weight-bold col-form-label">
                        Select
                      </label>
                      <div className="col-sm-12 col-md-12">
                        <Select
                          required
                          className=""
                          value={form_data.get("user")}
                          simpleValue
                          onChange={this.handleChangeSelect("user")}
                          name="user"
                          loadingPlaceholder="Loading..."
                          placeholder="Select User Type"
                          options={[
                            { label: "Job Seeker", value: "Job Seeker" },
                            { label: "Employer", value: "Employer" },
                          ]}
                        />
                      </div>
                    </div>
                    <div className="input-group mb-3 jobs-search-wrap flex-sm-column flex-md-row">
                      <label className="col-sm-12 font-weight-bold col-form-label">
                        Full Name
                      </label>
                      <div className="col-sm-12 col-md-12">
                        <input
                          type="text"
                          name="full_name"
                          className="form-control"
                          value={form_data.get("full_name")}
                          onChange={this.handleOnChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="input-group mb-3 jobs-search-wrap flex-sm-column flex-md-row">
                      <label className="col-sm-12 font-weight-bold  col-form-label">
                        Contact Number
                      </label>
                      <div className="col-sm-12 col-md-12">
                        <input
                          type="text"
                          name="contact"
                          className="form-control"
                          value={form_data.get("contact")}
                          onChange={this.handleOnChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="input-group mb-3 jobs-search-wrap flex-sm-column flex-md-row">
                      <label className="col-sm-12 font-weight-bold col-form-label">
                        Email Address
                      </label>
                      <div className="col-sm-12 col-md-12">
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          value={form_data.get("email")}
                          onChange={this.handleOnChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="input-group mb-3 jobs-search-wrap flex-sm-column flex-md-row">
                      <label className="col-sm-12 font-weight-bold col-form-label">
                        Message
                      </label>
                      <div className="col-sm-12 col-md-12">
                        <textarea
                          type="text"
                          name="message"
                          rows="5"
                          className="form-control"
                          value={form_data.get("message")}
                          onChange={this.handleOnChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="input-group mb-3 jobs-search-wrap flex-sm-column flex-md-row ">
                      <label className="col-sm-12 font-weight-bold col-form-label"></label>
                      <div className="col-sm-12 col-md-12">
                        <button
                          className="btn btn-block btn-lg btn-primary"
                          disabled={
                            form_data.get("user") &&
                            form_data.get("message") &&
                            form_data.get("email") &&
                            form_data.get("contact") &&
                            form_data.get("full_name") &&
                            form_data.get("user")
                              ? false
                              : true
                          }
                        >
                          {loading ? (
                            <i class="fa fa-spinner fa-pulse" />
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, routeParams) => {
  const form_data = state.auth.get("form_data");
  const { loadingTypes } = state.loading;
  const web_content = state.auth.get("web_content");

  return {
    form_data,
    web_content,
    loading: loadingTypes.length > 0,
  };
};

export default withRouter(connect(mapStateToProps)(JobSeeker));
